import React from 'react';
import { useIntl } from 'react-intl';
import { LayoutPage } from 'src/modules/layout';
import { ArticlesInstagramOverview } from 'src/modules/articles';
import { colInstagramCardPropsMagazinePage } from 'src/utils/grid';
import { LayoutPageHeading } from 'src/modules/layout';
import { FormattedMessage } from 'react-intl';
import styles from './ArticlesInstagramPage.module.scss';

const InstagramPage = () => {
  const intl = useIntl();

  const pageProperties = {
    title: intl.formatMessage({ id: 'page/magazine/listing/head/page_title' }),
    description: intl.formatMessage({ id: 'page/magazine/listing/head/meta_description' }),
    breadcrumbs: [
      {
        title: intl.formatMessage({ id: 'breadcrumbs/magazine' }),
        as: '/magazine',
        href: '/magazine',
      },
      {
        title: intl.formatMessage({ id: 'breadcrumbs/magazine/instagram' }),
        as: '/magazine/instagram',
        href: '/magazine/instagram',
      },
    ],
  };

  const sublineJsx = (
    <div className={styles.sublineContainer}>
      <FormattedMessage id="page/magazine/instagram_subline" />{' '}
      <a href={intl.formatMessage({ id: 'page/magazine/instagram_link_url' })}>
        <FormattedMessage id="page/magazine/instagram_link_url_display" />
      </a>
    </div>
  );

  return (
    <LayoutPage {...pageProperties}>
      <LayoutPageHeading titleKey="page/magazine/instagram_title" sublineJsx={sublineJsx} />
      <ArticlesInstagramOverview
        colProps={colInstagramCardPropsMagazinePage}
        numPosts="all"
        displayShowMore={true}
      />
    </LayoutPage>
  );
};

export default InstagramPage;
